/**
 * IMPORTANT: We need to keep the constants in this file and the ones in
 * the chrome extension repo in sync. Please mirror any changes here in the
 * constants/notifications.js file in the chrome extension repo
 */

export const VIDEO_READ = 'video_read';
export const ALL_COMMENTS_ENABLED = 'all_comments_enabled';
export const PUSH_VIDEO_READ = 'push_video_read';
export const PUSH_VIDEO_COMMENTS = 'push_video_comments';
export const PUSH_COMMENT_REPLIES = 'push_comment_replies';
export const PUSH_WEEKLY_DIGESTS = 'push_weekly_digests';
export const PUSH_VIDEO_REACTIONS = 'push_video_reactions';
export const VIDEO_SHARE = 'share_video';
export const PUSH_VIDEO_SHARE = 'push_share_video';
export const PUSH_VIDEO_RESHARE = 'push_reshare_video';
export const PUSH_VIDEO_PRIVACY_CHANGE = 'push_video_privacy_changed';

export const ALL_NOTIFICATION_SETTINGS = [
  VIDEO_READ,
  ALL_COMMENTS_ENABLED,
  PUSH_COMMENT_REPLIES,
  PUSH_VIDEO_COMMENTS,
  PUSH_VIDEO_READ,
  PUSH_WEEKLY_DIGESTS,
  PUSH_VIDEO_REACTIONS,
  VIDEO_SHARE,
  PUSH_VIDEO_SHARE,
  PUSH_VIDEO_RESHARE,
  PUSH_VIDEO_PRIVACY_CHANGE,
];
